import { ApolloClient } from '@apollo/client';
import { getDocumentById, getDocumentsByDeal } from '../../../api/queries_v2';
import { graphql } from '../../../gql';

/**
 * Unsend a lease document offer
 * @param documentId
 * @param dealId
 */

export function unsendDocument({
  documentId,
  dealId,
  additionalMessage,
}: {
  documentId: string;
  dealId: string;
  additionalMessage?: string;
}) {
  return function (client: ApolloClient<object>): Promise<any> {
    const variables = {
      documentId,
      additionalMessage,
    };

    const mutation = graphql(/* GraphQL */ `
      mutation unsendDocument($documentId: ID!, $additionalMessage: String) {
        unsendDocument(documentId: $documentId, additionalMessage: $additionalMessage) {
          id
        }
      }
    `);

    const refetchQueries = [
      {
        query: getDocumentsByDeal,
        variables: {
          dealId,
        },
      },
      {
        query: getDocumentById,
        variables: {
          documentId,
        },
      },
    ];

    return client
      .mutate({ mutation, variables, refetchQueries })
      .then(({ data }: Record<any, any>) => data.unsendDocument);
  };
}
